<template lang="pug">
img(v-if="!whiteLabel" :src="logoPath" :class="brand")
</template>

<script>
import config from "@/config";

export default {
  computed: {
    brand() {
      return config.brand;
    },
    whiteLabel() {
      return config.whiteLabel;
    },
    logoPath() {
      return config.logoPath;
    }
  },
  methods: {}
};
</script>
